import React, { useState, useEffect } from "react";
import { getBookingsByUser } from "../Common/apis";
import Loader from "../Loader/Loader.jsx";
import Aos from "aos";
import img2 from "../Assets/path.png";
import moment from "moment";

const Skillset = () => {
  useEffect(() => {
    Aos.init({
      duration: 1000, // animation duration in ms
      once: true // animate only once
    });
  }, []);
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [btn, setBtn] = useState("Enrolled Courses")

  useEffect(() => {
    fetchOrders();
  }, []);

  const fetchOrders = async () => {
    setLoading(true);
    try {
      const response = await getBookingsByUser();
      setOrders(response?.data || []);
    } catch (error) {
      console.error("Error fetching order history:", error);
    } finally {
      setLoading(false);
    }
  };


  // Even index orders
  const evenOrders = orders.filter((_, index) => index % 2 === 0);

  // Odd index orders
  const oddOrders = orders.filter((_, index) => index % 2 !== 0);

  return (
    <div className="profile-info pb-[100px]">
      <div className="profile-info-heading overflow-hidden">
        <h3 data-aos="fade-right" className="pb-[20px]">Your Skillset Journey</h3>
      </div>
      <div className="flex gap-[10px] pb-[55px]">
        <button className={`py-[8px] px-[14px] rounded-[8px] font-sans font-[500] text-[14px] leading-[18px] ${btn === "Enrolled Courses" ? "bg-[#F1E60D] text-[#263238]" : "bg-[#EDEDED] text-[#061C23]"}`} onClick={() => setBtn("Enrolled Courses")}>Enrolled Courses</button>
        <button className={`py-[8px] px-[14px] rounded-[8px] font-sans font-[500] text-[14px] leading-[18px] ${btn === "Active Courses" ? "bg-[#F1E60D] text-[#263238]" : "bg-[#EDEDED] text-[#061C23]"}`} onClick={() => setBtn("Active Courses")}>Active Courses</button>
        <button className={`py-[8px] px-[14px] rounded-[8px] font-sans font-[500] text-[14px] leading-[18px] ${btn === "Completed Courses" ? "bg-[#F1E60D] text-[#263238]" : "bg-[#EDEDED] text-[#061C23]"}`} onClick={() => setBtn("Completed Courses")}>Completed Courses</button>
      </div>
      {orders?.length > 0 && (
        <>
          <div className="skill-bg">
            <div className="min-w-max">
              <div className="flex items-start gap-[65px] mt-[46px]">
                {evenOrders.map((order, index) => (
                  <React.Fragment key={index}>
                    <div className="flex flex-col items-center">
                      <div className="top-circle">{moment(order.createdAt).format("DD-MM-YYYY hh:mm A")}</div>
                      <div className="circle-line"></div>
                    </div>
                    <div className="skill-box">
                      {order.courses.map((item) => (
                        <h6 key={item._id} className="skill-title">{item?.course?.name || ""}</h6>
                      ))}
                    </div>
                  </React.Fragment>
                ))}
              </div>

              <div className="flex items-end gap-[65px] mt-[-16px]">
                {oddOrders.map((order, index) => (
                  <React.Fragment key={index}>
                    <div className="skill-box">
                      {order.courses.map((item) => (
                        <h6 key={item._id} className="skill-title">{item?.course?.name || ""}</h6>
                      ))}
                    </div>
                    <div className="flex flex-col items-center">
                      <div className="circle-line-yellow"></div>
                      <div className="top-circle-yellow">{moment(order.createdAt).format("DD-MM-YYYY hh:mm A")}</div>
                    </div>
                  </React.Fragment>
                ))}
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Skillset;
